module.exports = __webpack_public_path__ + "img/banner.1ebb08af.png";